import React from "react";
import "../../Pages/Setting/Setting.css";
import { formatNotificationTime } from "../../Pages/utils/global";
import { AiOutlineDelete } from "react-icons/ai";

function DropdownForNotiFy({
  isOptionsVisible,
  setIsOptionsVisible,
  options,
  handleDeleteNotification,
}) {
  return (
    <>
      {isOptionsVisible === true && (
        <div>

          <div className="" onClick={() => setIsOptionsVisible(false)}></div>

          <div className="modal-content-notic">

            <div className="flex items-center justify-between px-3 py-[10px]">
              <h1 className="text-2xl FontFamily-Avenir-reg tracking-wide">Notification</h1>
              <span className="close-button" onClick={() => setIsOptionsVisible(false)}>&#10005;</span>

              
            </div>
            <hr></hr>
            

            <div className=" notic-subCont">
              <div className=" cursor-pointer ">

                {options?.length > 0 ? (
                  options?.map((opt, ind) => (
                    <div className="notifi-list ">
                      <div className="flex items-center justify-between py-2 ">
                        <div className="flex flex-col items-start">
                          <span className="text-base" key={opt._id + ind}>
                            {" "}
                            {opt.message}
                          </span>
                          <span className="pt-[10px]">
                            {formatNotificationTime(opt?.createdAt)}
                          </span>
                        </div>
                        <span
                          style={{ marginLeft: "auto", cursor: "pointer" }}
                          onClick={() => handleDeleteNotification(opt._id)}
                        >
                          <AiOutlineDelete />
                        </span>
                      </div>
                    </div>
                  ))
                ) : (
                  <span>no notification</span>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DropdownForNotiFy;
